import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isMobile from 'is-mobile';

import VideoUploadButton from './VideoUploadButton';
import VideoRecorderEnableButton from './VideoRecorderEnableButton';
import {
  getShouldShowCameraRecorder,
  getShouldShowPostRecordingActions
} from '../../redux/modules/campaignLandingPage';
import styles from './UploadOrRecordSelector.module.less';

const UploadOrRecordSelector = ({
  qid,
  shouldShowCameraRecorder,
  shouldShowPostRecordingActions
}) => {
  if (shouldShowCameraRecorder || shouldShowPostRecordingActions) {
    return null;
  }

  return (
    <section className={styles.vpButtonContainer}>
      {isMobile({ tablet: true }) ? (
        <VideoUploadButton qid={qid} urlType="clpVideoUpload" isDirectRecording />
      ) : (
        <VideoRecorderEnableButton qid={qid} />
      )}
      <VideoUploadButton qid={qid} urlType="clpVideoUpload" /> {/* appears on both */}
    </section>
  );
};

UploadOrRecordSelector.propTypes = {
  _showCameraRecorder: PropTypes.func,
  qid: PropTypes.string,
  shouldShowCameraRecorder: PropTypes.bool,
  shouldShowPostRecordingActions: PropTypes.bool
};

function mapStateToProps(state, ownProps) {
  return {
    shouldShowCameraRecorder: getShouldShowCameraRecorder(state, ownProps.qid),
    shouldShowPostRecordingActions: getShouldShowPostRecordingActions(state, ownProps.qid)
  };
}

export default connect(mapStateToProps)(UploadOrRecordSelector);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/UploadOrRecordSelector.jsx